import React from 'react';

// Reference https://icons.getbootstrap.com/icons/camera-video/

const CameraVideo = ({ styles = {}, stroke }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        className="bi bi-camera-video"
        viewBox="0 0 16 16"
        style={styles}
      >
        <path
          stroke={stroke || '#C4C4C4'}
          strokeWidth="0"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"
        />
      </svg>
    </div>
  );
};

export default CameraVideo;
